module.exports = __webpack_public_path__ + "static/media/ovest1.a5996ae0.svg";